import {
  DvFormElementParams,
  DvNumberInputElement,
  DvNumberInputElementParams,
  FormType,
} from '@devinco/ui/dds';
import { FormElementExtra } from './form.element';

export class VtNumberInputElement<
  TForm extends FormType = FormType,
  TFormContext = any,
> extends DvNumberInputElement<TForm, TFormContext> {
  constructor(params: VtNumberInputElementParams<TForm, TFormContext>) {
    super(params);
    params.elementParams ??= {};
    params.extra ??= {};
  }
}

export interface VtNumberInputElementParams<
  TForm extends FormType,
  TFormContext = any,
> extends DvFormElementParams<{
  TForm: TForm;
  TFormContext: TFormContext;
  TElementParams: DvNumberInputElementParams;
}> {
  extra?: FormElementExtra;
}
